import styled from 'styled-components';
import IcoW01 from 'dc/IcoW01';
import StreakCircleComponent from '../../../common/StreakCircle';
import Mod001 from 'dc/Mod001';
import { Typ41, Typ35 } from 'dc/Typ';
import SeF001 from 'dc/Sef001';

export const Modal = styled(Mod001)`
  width: 646px !important;
  > div {
    border-radius: 5px;
    box-shadow:
      0 15px 20px rgba(0, 0, 0, 0.22),
      0 19px 60px rgba(0, 0, 0, 0.3);
  }
`;

export const CloseIconContainer = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const CloseIcon = styled(IcoW01)`
  cursor: pointer;
  color: #607d8b;
  &:hover {
    color: #263238;
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  background-color: transparent;
  text-align: center;
`;

export const StreakCircle = styled(StreakCircleComponent)``;

export const Title = styled(Typ41)`
  margin: 32px 0 8px 0;
  max-width: 244px;
  text-align: center;
`;

export const Text = styled(Typ35)`
  margin-bottom: 48px;
  max-width: 244px;
  text-align: center;
`;

export const KeyWrapper = styled.div`
  width: calc(100% - 180px);
  margin-bottom: 36px;
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

export const KeyItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  flex-basis: 0;
`;

export const KeyTitle = styled(Typ41)`
  font-size: 20px;
  margin-bottom: 8px;
`;

export const KeyBlock = styled.div`
  width: 24px;
  height: 12px;
  background: ${props => props.color};
  margin-bottom: 8px;
`;

export const KeyText = styled(Typ35)`
  color: #000;
`;

export const Footer = styled(SeF001)``;
